import React, { useState, useEffect } from "react";
import {
  useTable,
  usePagination,
  useSortBy,
  useGlobalFilter,
} from "react-table";
import {
  fetchProjects,
  deleteProject,
  updateProject,
  verifyAdmin,
} from "../../../utils/api";
import UpdateProjectModal from "./UpdateProjectModal";
import Modal from "react-modal";
import { AiOutlineClose } from "react-icons/ai";
import DynamicTable from "./DynamicTable";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { useDisclosure } from "@chakra-ui/react";
import AdminCredential from "../../../auth/AdminCredential";
import AdminCredentialModal from "../../../auth/AdminCredentialModal";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "90%", // Example width for the modal
    maxWidth: "850px", // Example maximum width for the modal
    backgroundColor: "#171717",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  closeButton: {
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem",
    cursor: "pointer",
    backgroundColor: "#fff",
    borderRadius: "50%",
    padding: "0.25rem",
  },
};
const UpdateProjects = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProject, setSelectedProject] = useState(null); // State for selected project
  const token = localStorage.getItem('tokenId');

  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    subtitle.style.color = "#f00";
  }

// sourcery skip: avoid-function-declarations-in-blocks
  function closeModal() {
    setIsOpen(false);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const projects = await fetchProjects();
      setData(projects);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };



  const [overlay, setOverlay] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const openCredentialModal = () => {
    setOverlay(<AdminCredential />);
    onOpen();
  };

  const closeCredentialModal = () => {
    setOverlay(null);
    onClose();
  };

  const handleDelete = async (rowData) => {
    try {
      const token = localStorage.getItem('tokenId');
      if (!token) {
        const alertResult = await Swal.fire({
          title: 'Admin Credential Required',
          text: 'To delete a project, you need valid admin credentials. Would you like to provide them?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          background: 'rgba(0, 0, 0, 0.9)',
          confirmButtonColor: "#DF7E07",
        });

        if (alertResult.isConfirmed) {
          // Open the admin credential modal
          openCredentialModal();
        }
      } else {
        const isAdmin = await verifyAdmin(token);
        if (isAdmin) {
          await deleteProject(rowData._id);
          setData((prevData) =>
            prevData.filter((item) => item._id !== rowData._id)
          );
          toast.success('Project Deleted successfully');
        } else {
          toast.error('You do not have permission to delete.');
        }
      }
    } catch (error) {
      toast.error('An error occurred');
    }
  };

  const handleUpdate = async (rowData) => {
    try {
      const token = localStorage.getItem('tokenId');
      if (!token) {
        const alertResult = await Swal.fire({
          title: 'Admin Credential Required',
          text: 'To update a project, you need valid admin credentials. Would you like to provide them?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          background: 'rgba(0, 0, 0, 0.9)',
          confirmButtonColor: "#DF7E07",
        });

        if (alertResult.isConfirmed) {
          // Open the admin credential modal
          openCredentialModal();
        }
      } else {
        const isAdmin = await verifyAdmin(token);
        if (isAdmin) {
          setSelectedProject(rowData);
          setIsOpen(true);
        } else {
          toast.error('You do not have permission to update.');
        }
      }
    } catch (error) {
      toast.error('An error occurred');
    }
  };

  const handleSave = async (updatedData) => {
    try {
      await updateProject(selectedProject._id, updatedData);
      // setIsModalOpen(false); // Close the modal after saving
      setIsOpen(false);

      // Find the index of the updated project in the data array
      const updatedIndex = data.findIndex(
        (item) => item._id === selectedProject._id
      );
      if (updatedIndex !== -1) {
        // Create a shallow copy of the data array
        const newData = [...data];
        // Update the project at the specified index with the updatedData
        newData[updatedIndex] = {
          ...newData[updatedIndex],
          ...updatedData,
        };
        // Update the data state with the updated array
        setData(newData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Category",
        accessor: "category",
        disableSortBy: false,
      },
      {
        Header: "Image",
        accessor: "links.bannerImg",
        disableSortBy: false,
        Cell: ({ value }) => (
          // eslint-disable-next-line jsx-a11y/img-redundant-alt
          <img
            src={value}
            alt="Project Image"
            style={{ width: "25px", height: "25px", borderRadius: "50%" }}
          />
        ),
      },
      {
        Header: "Project Title",
        accessor: "links.details.titleSmall",
        disableSortBy: false,
      },
      {
        Header: "Date",
        accessor: "date",
        disableSortBy: false,
        Cell: ({ value }) => (
          <span>{new Date(value).toLocaleDateString()}</span>
        ),
      },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="flex items-center">
            {row.original.links.live && (
              <a
                href={row.original.links.live}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
              </a>
            )}
            <button onClick={() => handleUpdate(row.original)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                />
              </svg>
            </button>
            <button onClick={() => handleDelete(row.original)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    previousPage,
    nextPage,
    pageOptions,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 6 }, // Set the pageSize option to 6
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageIndex, globalFilter } = state;

  return (
    <>
 <AdminCredentialModal isOpen={isOpen} onClose={closeCredentialModal} overlay={overlay} />
 
    <div className=" mx-auto mt-20 flex flex-col items-center justify-center shadow-lg w-[80%] bg-slate-700 rounded-lg p-10">
      {/* Search Bar */}

      <DynamicTable
      headerGroups={headerGroups}
      getTableBodyProps={getTableBodyProps}
      page={page}
      prepareRow={prepareRow}
      globalFilter={globalFilter}
      setGlobalFilter={setGlobalFilter}
      loading={loading}
      previousPage={previousPage}
      canPreviousPage={canPreviousPage}
      pageIndex={pageIndex}
      pageOptions={pageOptions}
      nextPage={nextPage}
      canNextPage={canNextPage}
    />

      <div>
        {modalIsOpen && (
          <div>
            <button onClick={openModal}>Open Modal</button>
            <Modal
              isOpen={modalIsOpen}
              onAfterOpen={afterOpenModal}
              onRequestClose={closeModal}
              style={customStyles}
              contentLabel="Example Modal"
            >
              <div style={customStyles.closeButton}>
                <AiOutlineClose
                  onClick={closeModal}
                  size={24}
                  style={{ color: "#fffff", borderRadius: "50%" }}
                />
              </div>
              {/* <button onClick={closeModal}>close</button> */}
              <UpdateProjectModal
                project={selectedProject}
                onSave={handleSave}
                onClose={() => setIsOpen(false)}
              />
            </Modal>
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default UpdateProjects;
